var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.height)},[_c('MainMenu',{attrs:{"menu-name":"clientmenu","menu-items":_vm.items,"route-prefix":"/client"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }